import { render } from "./KSChangeReportOwner.vue?vue&type=template&id=3eb29364"
import script from "./KSChangeReportOwner.vue?vue&type=script&lang=js"
export * from "./KSChangeReportOwner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__